import AdviserProfilesApi from '../api/AdviserProfilesApi'

export const events = {
  fetched: {
    publishedProfile: 'FETCHED_PUBLISHED_PROFILE'
  },
  fetching: {
    publishedProfile: 'FETCHING_PUBLISHED_PROFILE'
  }
}

export const fetchingPublishedProfile = adviserId => ({
  type: events.fetching.publishedProfile,
  adviserId
})

export function fetchPublishedProfile (adviserId) {
  const api = new AdviserProfilesApi()
  const profileRequest = api.getPublishedAdviserProfile(adviserId)
  
  return dispatch => {
    dispatch(fetchingPublishedProfile(adviserId))
    profileRequest
      .then(function (response) {
        dispatch(api.handleResponse(events.fetched.publishedProfile, response))
      })
      .catch(function (err) {
        // eslint-disable-next-line no-console
        console.error('Adviser fetch by ID failed: ==== ', err)
      })
  }
}
